module.exports = "/_next/static/images/search_bg_3-03b9dcd8320b79b25f8b70370f6db668.jpg";